import React, { PropTypes } from 'react';
import DataService from '../../lib/DataService';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import { hashHistory, Link } from 'react-router';
import { Modal, Input, message, Popconfirm, Spin } from 'antd';
import ReactQiniuModule from '../../../../lib/ReactQiniuModule';
const { TextArea } = Input;

export default class ClassAlbumEditPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      role: CurrentRoleStore.getCurrentRole(),
      albumId: props.params.albumId,
      classId: props.location.query.classId,
      album: {},
      uploading: false,
      uploadedFiles: [],
      uploadingFiles: [],
    };
    // bind this
    this.getAvailableQuotaForUploadingFiles = this.getAvailableQuotaForUploadingFiles.bind(this);
    this.isAllUploadingFileFinished = this.isAllUploadingFileFinished.bind(this);
    this.onFileUploadSuccess = this.onFileUploadSuccess.bind(this);
    this.onFileStartUpload = this.onFileStartUpload.bind(this);
    this.deleteAlbum = this.deleteAlbum.bind(this);
    this.submit = this.submit.bind(this);

  }

  componentDidMount() {
    CurrentRoleStore.addChangeListener(this.onRolesChange);
    if(this.state.albumId){
      DataService.getAlbum(this.state.albumId).then((album) => {
      this.setState({
        album: album,
      });
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  componentWillUnmount() {
    CurrentRoleStore.removeChangeListener(this.onRolesChange);
  }

  inputPassword(state, e) {
    let album = this.state.album;
    album[state] = e.target.value;
    this.setState({
      album: album
    })
  }

  getAvailableQuotaForUploadingFiles() {
    return true;
  }

  isAllUploadingFileFinished() {
    return !this.state.uploading;
  }

  onFileStartUpload(newFileKey) {
    this.setState({
      uploading: true
    })
    return true;
  }

  onFileUploadSuccess(newFileKey, fileName, size, remoteUrl) {
    let album = this.state.album;
    album.cover = remoteUrl;
    this.setState({
      album: album,
      uploading: false
    });
  }

  deleteAlbum() {
    let albumId = this.state.albumId;
    DataService.deleteAlbum(albumId).then((res) => {
      message.info("相册已成功删除！")
      setTimeout(function(){hashHistory.goBack();}, 1000)
    }).catch((error) => {
      console.log(error);
    });
  }

  submit() {
    let album = this.state.album;
    let classId = this.state.classId;
    let role = this.state.role.associatName;
    if(!this.state.albumId){
      if(!album.title || !album.cover){
        message.info("请确保已经填写相册标题及封面")
      }else{
        message.loading('提交中..',1);
        let data = {
          class_record_id: classId,
          title: album.title,
          cover: album.cover,
        }
        if(album.description){
          data.description = album.description;
        }
        DataService.createAlbum(data).then((res) => {
          setTimeout(function(){hashHistory.goBack();}, 1000)
        }).catch((error) => {
          console.log(error);
        });
      }
    }else {
      message.loading('提交中..',1);
      let albumId = this.state.albumId;
      let data = {
        title: album.title,
        cover: album.cover,
      }
      if(album.description){
        data.description = album.description;
      }
      DataService.updateAlbum(albumId, data).then((res) => {
        setTimeout(function(){hashHistory.goBack();}, 1000)
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  render() {
    return (
      <div className="albums-edit-page">
        <div className="albums-detail-container">
          <div className="albums-detail-title-text">相册名称</div>
          <Input className="albums-detail-title-input" value={this.state.album.title || ''}  onChange={this.inputPassword.bind(this, 'title')} />
          <div className="albums-detail-title-text">相册简介</div>
          <TextArea autosize className="albums-detail-title-input intro" value={this.state.album.description || ''} onChange={this.inputPassword.bind(this, 'description')} />
          <div className="albums-detail-title-text">相册封面</div>
          {this.state.album.cover &&
            <ReactQiniuModule
                className="edit-cover"
                onSuccess={this.onFileUploadSuccess}
                onStartPermit={this.onFileStartUpload}
                isAllFinish={this.isAllUploadingFileFinished}
                getUploadQuota={this.getAvailableQuotaForUploadingFiles}
                allowUploadFileTypes={ReactQiniuModule.getFileCategories.ALL}
                allowUploadFileSize={10} >
              {this.state.uploading &&
                <Spin tip="Loading...">
                  <img src={this.state.album.cover} className="albums-detail-cover-img" />
                </Spin>
              }
              {!this.state.uploading &&
                <img src={this.state.album.cover} className="albums-detail-cover-img" />
              }
              <div className="albums-detail-cover-img-text" onClick={this.uploadAvatar}>更换照片</div>
            </ReactQiniuModule>
            }
          {this.state.albumId && <Popconfirm placement="bottomRight" title="删除相册后里面的照片也会一并删除" onConfirm={this.deleteAlbum} okText="确认删除" cancelText="取消"><div className="albums-detail-delete">删除此相册</div></Popconfirm> }
          {!this.state.album.cover &&
            <ReactQiniuModule
                className="edit-cover"
                onSuccess={this.onFileUploadSuccess}
                onStartPermit={this.onFileStartUpload}
                isAllFinish={this.isAllUploadingFileFinished}
                getUploadQuota={this.getAvailableQuotaForUploadingFiles}
                allowUploadFileTypes={ReactQiniuModule.getFileCategories.ALL}
                allowUploadFileSize={10} >
              {this.state.uploading &&
                <Spin tip="Loading...">
                  <div className="albums-detail-cover-img-default"></div>
                </Spin>
              }
              {!this.state.uploading &&
                <div className="albums-detail-cover-img-default"></div>
              }
            </ReactQiniuModule>
            }
        </div>
        <div className="albums-detail-btn" onClick={this.submit} >{this.state.albumId ? '保 存' : '确 认'}</div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/album/ClassAlbumEditPage.jsx